<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Center for Pharmaceutical Innovation</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:70%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">Center for Pharmaceutical Innovation aims to build an advanced \n' +
      'and comprehensive pharmaceutical technology center and provide services of clinical omics analysis, drug screening, pharmaceutical analysis, quality control, product isolation/purification, \n' +
      'and chemical process safety assessment, aiming to develop firstclass "one-stop" scientific services for all research institutions \n' +
      'and enterprises.</span></p>'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">The center currently has an expert team, research team and professional technical service team as well as a top class of instruments. Based on the research and development needs of the new \n' +
      'drug innovation, our center provides whole-process and comprehensive technology services.</span></p>'

      + '</div>'


      + '<div id="right" style="float:left ; width:30%; height:100%;">'
      + '<p style="margin-left : 50px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/zhaoguozhang.jpg" style="float: center; width: 200px;  margin-right: 40px;"  border="0" vspace="0" alt=""></p>'
      + '<p style="margin-bottom : 20px;text-align: justify"><span style="font-size: 10px;"><b>Director:  Zhaoguo Zhang</b><br>Professor, Dean of the Instrumental Analysis Center of Shanghai JiaoTong University. Chinese Academy of Sciences "Hundred Talents Program" Award / Shanghai Shuguang Scholar Award <br>Research Field: asymmetric cataly-</span></p>'
      + '</div>'
      + '<p style="margin-left : 20px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/pharmaceutical_innovation_en.jpg" style="float: left; width: 1200px;  margin-right: 20px;" border="0" vspace="0" alt=""></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Li Zhang</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: lizhang09@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Phone: +86-021-34208498-6421, +8613816938311</span></p>'
      + '<p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service3/en/index.vue